import { t } from 'app/i18l'
import { useRoutingContext } from 'app/routing_context'
import { useCompaniesContext } from 'company/context'
import { GoldStarsScreenProps } from 'home/stack/types'
import { useCallback, useLayoutEffect } from 'react'
import { StatusBoundary } from 'shared/components/status_boundary'
import { showHeaderTitle } from 'shared/header/header_title'
import { useUser } from 'users/queries/detail'
import { GoldStarsView } from './views'

export function GoldStarsScreen({ navigation, route }: GoldStarsScreenProps) {
  const { activeCompany } = useCompaniesContext()
  const userQuery = useUser(undefined, activeCompany?.id)

  const { handleNavigation } = useRoutingContext()

  useLayoutEffect(() => {
    showHeaderTitle(navigation, t('goldStars'))
  }, [navigation])

  const onPressTransfer = useCallback(() => {
    handleNavigation({
      routeName: 'star_recipients',
      routeParams: {
        type: 'transfer',
      },
    })
  }, [handleNavigation])

  const onPressViewTransactions = useCallback(() => {
    handleNavigation({
      routeName: 'star_transactions',
    })
  }, [handleNavigation])

  return (
    <StatusBoundary
      isLoading={userQuery.isLoading}
      error={userQuery.error}
    >
      <GoldStarsView
        user={userQuery.data}
        onPressTransfer={onPressTransfer}
        onPressViewTransactions={onPressViewTransactions}
      />
    </StatusBoundary>
  )
}
